export enum EmbedVideoType {
  YOUTUBE,
  VIMEO
}
